import { render, staticRenderFns } from "./WingsDigitalSignage.vue?vue&type=template&id=1f4e0b74&scoped=true"
import script from "./WingsDigitalSignage.ts?vue&type=script&lang=ts&external"
export * from "./WingsDigitalSignage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e0b74",
  null
  
)

export default component.exports